export default __webpack_public_path__ + "static/favicon-ae0205ee06f83eaf396e1c78f935d049.ico";